import React from "react";

function GuideSteps({ steps = [] }) {
    if (!steps.length) return null;

    return (
        <ol className="space-y-3">
            {steps.map((step, index) => (
                <li
                    key={`${step.title || step}-${index}`}
                    className="flex min-w-0 gap-3 text-sm text-slate-600"
                >
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-indigo-50 text-xs font-bold text-indigo-700">
                        {index + 1}
                    </span>
                    <span className="min-w-0 pt-0.5">
                        {typeof step === "string" ? (
                            step
                        ) : (
                            <>
                                <span className="block font-semibold text-slate-800">
                                    {step.title}
                                </span>
                                {step.description && (
                                    <span className="mt-1 block leading-6">
                                        {step.description}
                                    </span>
                                )}
                            </>
                        )}
                    </span>
                </li>
            ))}
        </ol>
    );
}

export default GuideSteps;
